import React from "react";
import BaseButton from "./BaseButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const CreateButton = ({ children, ...rest }) => {
  return (
    <BaseButton {...rest}>
      <i className="btn-icon">
        <AddCircleIcon fontSize="small" />
      </i>

      {children}
    </BaseButton>
  );
};

export default CreateButton;
